import {Api, apiUrls} from "../../helpers/api";
import http from "../../common/services/httpService";
import {ReportFileFormat} from "../models/reportFileFormatEnum";
import {PageableModel} from "../../common/models/table";
import {AxiosResponse} from "axios";
import {DownloadService} from "../../common/services/downloadService";
import {VehicleOrCargoHandlingTimeModel, VehicleOrCargoHandlingTimeFilters} from "../models/vehicleOrCargoHandlingTime";

export class VehicleOrCargoHandlingTimeService {
    private static baseUrl = apiUrls.reports.vehicleOrCargoHandlingTime;

    public static async generateReport(filters: VehicleOrCargoHandlingTimeFilters): Promise<AxiosResponse<PageableModel<VehicleOrCargoHandlingTimeModel>>> {
        const url = Api.getUrl(this.baseUrl);

        return await http.get<PageableModel<VehicleOrCargoHandlingTimeModel>>(
            `${Api.addParams(url, this.getParams(filters))}`
        );
    }

    public static async download(filters: VehicleOrCargoHandlingTimeFilters, fileFormat: ReportFileFormat): Promise<AxiosResponse> {
        const mediaType = fileFormat === ReportFileFormat.xls ? "application/xls" : "application/csv";

        return DownloadService.download(this.baseUrl, mediaType, this.getParams(filters));
    }

    private static getParams(filters: VehicleOrCargoHandlingTimeFilters) {
        return `bookingNo=${filters.bookingNo}&lorryRegNo=${filters.lorryRegNo}` +
            `&trailerRegNo=${filters.trailerRegNo}&containerNo=${filters.containerNo}` +
            `&wagonRegNo=${filters.wagonRegNo}&dateFrom=${filters.dateFrom}&dateTo=${filters.dateTo}`;
    }
}
